import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { get} from '../../request'
import './styles.scss';


function Pagination({ totalItems, itemsPerPage, onPageChange   }) {
    const [currentPage, setCurrentPage] = useState(1);
    // 计算总页数  
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        onPageChange(newPage);
    };

    const renderPageButtons = () => {
        const pageButtons = [];
        const maxButtons = 4; // 最多显示的页码按钮数量（包括首页、末页）  
        if (totalPages <= maxButtons) {
            // 如果总页数小于或等于maxButtons，则直接显示所有页码  
            for (let i = 1; i <= totalPages; i++) {
                pageButtons.push(
                    <button
                        key={i}
                        onClick={() => handlePageChange(i)}
                        className={`page-button ${currentPage === i ? 'active' : ''}`}
                    >
                        {i}
                    </button>
                );
            }
        } else {
            // 如果总页数大于maxButtons，则显示省略号  
            const startPage = Math.max(2, currentPage - Math.floor((maxButtons - 2) / 2));
            const endPage = Math.min(totalPages - 1, startPage + maxButtons - 2);

            // 添加首页按钮  
            pageButtons.push(
                <button
                    key="first"
                    onClick={() => handlePageChange(1)}
                    className={`page-button ${currentPage === 1 ? 'active' : ''}`}
                >
                    1
                </button>
            );

            // 添加省略号（如果总页数超过maxButtons）  
            if (startPage > 2) {
                pageButtons.push(<span key="dots-start">...</span>);
            }

            // 添加中间的页码按钮  
            for (let i = startPage; i <= endPage; i++) {
                pageButtons.push(
                    <button
                        key={i}
                        onClick={() => handlePageChange(i)}
                        className={`page-button ${currentPage === i ? 'active' : ''}`}
                    >
                        {i}
                    </button>
                );
            }

            // 如果还有更多页码未显示，则添加省略号  
            if (endPage < totalPages - 1) {
                pageButtons.push(<span key="dots-end">...</span>);
            }

            // 添加末页按钮  
            pageButtons.push(
                <button
                    key="last"
                    onClick={() => handlePageChange(totalPages)}
                    className={`page-button ${currentPage === totalPages ? 'active' : ''}`}
                >
                    {totalPages}
                </button>
            );
        }

        return pageButtons;
    };

    const [screenSize, setScreenSize] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
            setScreenSize(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (
        <div className="pagination">
            <button onClick={() => handlePageChange(1)} disabled={currentPage === 1}>
                {
                    screenSize > 991 ? "首页" :"<<"
                }
            </button>
            <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
            >
                
                {
                    screenSize > 991 ? "上一页" : "<"
                }
            </button>
            {renderPageButtons()}
            <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
            >
                
                {
                    screenSize > 991 ? "下一页" : ">"
                }
            </button>
            <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>
                {
                    screenSize > 991 ? "下一页" : ">>"
                }
            </button>
        </div>
    );
};

export default Pagination ;